import * as THREE from "three";

export class Renderer extends THREE.WebGLRenderer {
  constructor() {
    super({ antialias: true });

    this.setPixelRatio(Math.min(window.devicePixelRatio, 1));
    this.setSize(window.innerWidth, window.innerHeight);

    this.outputColorSpace = THREE.SRGBColorSpace;
    this.toneMapping = THREE.ACESFilmicToneMapping;
    this.toneMappingExposure = 1;
    this.shadowMap.enabled = true;
    this.shadowMap.type = THREE.PCFSoftShadowMap;
    this.physicallyCorrectLights = true;
  }
}
